import React from "react"
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  TableContainer,
  Flex,
} from "@chakra-ui/react"

export default function DevTable() {
  const names = ["John", "Jane", "Jim", "Jill"]
  const lastNames = ["Doe", "Smith", "Johnson", "Williams", "Adamns"]
  const ages = [25, 32, 35, 48, 51, 63]
  const genders = ["Male", "Female"]
  const addresses = [
    "123 PizzaPie St",
    "456 MooDeng Ave",
    "6399 Bepis St",
    "420 Altitude St",
    "404 Dad street",
    "80085 CalculatorJoke Way",
    "8888 Erebus culdesac",
  ]
  const telephoneNumbers = [
    "555-456-7890",
    "555-654-3210",
    "555-123-4567",
    "555-222-3333",
    "555-867-5309",
    "555-867-5309",
    "555-867-5309",
    "555-867-5309",
  ]

  const generateTableData = () => {
    const tableData = []
    for (let i = 0; i < 50; i++) {
      tableData.push({
        firstName: names[Math.floor(Math.random() * names.length)],
        lastName: lastNames[Math.floor(Math.random() * lastNames.length)],
        age: ages[Math.floor(Math.random() * ages.length)],
        gender: genders[Math.floor(Math.random() * genders.length)],
        address: addresses[Math.floor(Math.random() * addresses.length)],
        telephone:
          telephoneNumbers[Math.floor(Math.random() * telephoneNumbers.length)],
      })
    }
    return tableData
  }

  const tableData = generateTableData()

  return (
    <Flex direction="column" flexGrow={1} minHeight={0}>
      <TableContainer
        flex="1"
        borderRadius="0.5em"
        boxShadow="lg"
        overflowY="auto"
        bg="white"
        minHeight="0"
      >
        <Table>
          <Thead>
            <Tr>
              <Th>
                <Text>First Name</Text>
              </Th>
              <Th>
                <Text>Last Name</Text>
              </Th>
              <Th>
                <Text>Age</Text>
              </Th>
              <Th>
                <Text>Gender</Text>
              </Th>
              <Th>
                <Text>Address</Text>
              </Th>
              <Th>
                <Text>Telephone Number</Text>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {tableData.map((row, index) => (
              <Tr key={index}>
                <Td>{row.firstName}</Td>
                <Td>{row.lastName}</Td>
                <Td>{row.age}</Td>
                <Td>{row.gender}</Td>
                <Td>{row.address}</Td>
                <Td>{row.telephone}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Flex>
  )
}
